// import React, {useState, useEffect} from 'react'

import Table from 'react-bootstrap/Table'
// import {useTable} from 'react-table'
import '../../App.css'
import {useTranslation} from "react-i18next"
import { Link } from 'react-router-dom';

function Content() {
  const {t} = useTranslation();
  // const [userList, setUserList] = useState([]);
  const notice = [
    {id: "1", text:"[사용자] 규제샌드박스 실증특례 고지", date:"2021-12-27"},
    {id: "2", text:" [사용자, 관리자] 홈페이지 오픈", date:"2021-12-28"},
    {id: "3", text:"[사용자] 2021년 6월 업데이트 내용"}
  ]
  console.log(notice[0].id)
  // console.log(notice.text[0])

  // useEffect(() => {
  //   fetch("https://jsonplaceholder.typicode.com/users")
  //   .then(response => response.json())
  //   .then(result => setUserList(result))
  //   .catch(error => console.log(error));
  // }, [])
  // useTable({
  //   columns: columns,
  //   data: userList
  // })
  // const notice ={
  //   text:"[사용자] 2021년 6월 업데이트 내용"
  // }

  return (
    <div>
      <div style={{height:"800px", textAlign:"-webkit-center", marginTop:"150px"}}>
        <div className='noticeAll'style={{position:"relative", marginBottom:"50px"}}>
          <h1 style={{color:"#2783C6"}}>{t("notice.notice")}</h1>
          <Table hover>
            <thead className=''>
              <tr>
                <th style={{color:"#2783C6"}}>{t("notice.top.num")}</th>
                <th style={{color:"#2783C6"}} colSpan="5">{t("notice.top.theme")}</th>
                <th style={{color:"#2783C6"}}>{t("notice.top.date")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>{notice[1].id}</b></td>
                <td colSpan="5" id="1"><Link to={`/notice/${notice[1].id}`} style={{textDecoration:"none" ,color:"black"}}>{notice[1].text}</Link></td>
                <td>{notice[1].date}</td>
              </tr>
              <tr>
                <td><b>{notice[0].id}</b></td>
                <td colSpan="5" id="1"><Link to={`/notice/${notice[0].id}`} style={{textDecoration:"black" ,color:"black"}}>{notice[0].text}</Link></td>
                <td>{notice[0].date}</td>
              </tr>
              {/* {data.map((notice, index) =>{
                return(
                  <tr key={index}>
                    <td><b>{notice[index].id}</b></td>
                    <td colSpan="5" id="1"><Link to={`/notice/${notice[0].id}`}>{notice[index].text}</Link></td>
                    <td>2021-06-30</td>
                  </tr>
                );
              })} */}
              
            </tbody>
            <tfoot>
            <tr>
              <td><b></b></td>
              <td colSpan="5"></td>
              <td></td>
            </tr>
            </tfoot>
          </Table>
          <div className='noticeNum' style={{ position:"relative", letterSpacing:"2px"}}>
            <br/><br/> <span>  &lt;&lt;   &lt; &nbsp; 1 &nbsp; &gt; &gt;&gt; </span> </div>
          <div className='noticeSearch' style={{ position:"relative",  letterSpacing:"2px"}}><span> <br/><br/><br/><select style={{ border: "none",
            borderBottom: "1px solid",color: "#ADB5BD"}} name="cars" id="cars">
            <option value="volvo">{t("notice.top.option")}</option>
            <option value="volvo">{t("notice.top.option")}</option>
            </select> <input style={{ border: "none", borderBottom: "1px solid",color: "#ADB5BD", width:"200px"}} />&nbsp;&nbsp;
            <button style={{ border: "none", background:"none", borderBottom: "1px solid",color: "#2783C6", width:"50px"}}>{t("notice.top.button")}</button></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Content
